import { WebPage } from '../types/page.types';
import styles from './PageContent.module.css';

interface PageContentProps {
  page: WebPage;
}

function PageContent({ page }: PageContentProps) {
  return (
    <article className={styles.article}>
      {page.coverImage && (
        <div className={styles.coverImage}>
          <img src={page.coverImage} alt={page.title} />
        </div>
      )}
      <div className={styles.content}>
        <h1 className={styles.title}>{page.title}</h1>
        <div
          className={styles.body}
          dangerouslySetInnerHTML={{ __html: page.bodyHtml }}
        />
      </div>
    </article>
  );
}

export default PageContent;
